/* One runtime for all sections, including Shopify editor re-renders. */
(() => {
  if (window.LAStorySections) return;
  const state = window.LAStorySections = { opener: null, locked: false };
  function ensureModal() {
    if (state.dialog?.isConnected) return state.dialog;
    const host = document.createElement('div');
    host.className = 'ls-root ls-modal-host';
    host.innerHTML = '<dialog class="ls-dialog" aria-labelledby="ls-active-dialog-title"><button class="ls-close" type="button" aria-label="Close dialog" data-ls-close>×</button><div class="ls-dialog-body"></div></dialog>';
    document.body.append(host);
    const dialog = state.dialog = host.querySelector('dialog');
    dialog.addEventListener('close', () => {
      if (state.locked) { document.body.style.overflow = state.overflow; state.locked = false; }
      if (state.opener?.isConnected) state.opener.focus({ preventScroll: true });
    });
    dialog.addEventListener('click', e => {
      const r = dialog.getBoundingClientRect();
      if (e.target === dialog && (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom)) dialog.close();
    });
    return dialog;
  }
  function show(content, opener) {
    const d = ensureModal();
    if (!d.open) state.opener = opener;
    const body = d.querySelector('.ls-dialog-body');
    body.replaceChildren(content);
    const title = body.querySelector('[data-ls-modal-title],h2');
    if (title) title.id = 'ls-active-dialog-title';
    if (!state.locked) { state.overflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; state.locked = true; }
    if (!d.open) d.showModal();
    d.querySelector('[data-ls-close]').focus();
  }
  function booking(opener) {
    const config = document.querySelector('[data-ls-booking-config]');
    const content = document.createElement('div');
    const heading = document.createElement('h2');
    heading.textContent = config?.dataset.title || 'Try on wedding dresses';
    content.append(heading);
    let url;
    try {
      url = new URL(config?.dataset.url || '');
      if (url.protocol !== 'https:' || !(url.hostname === 'koalendar.com' || url.hostname.endsWith('.koalendar.com'))) url = null;
    } catch (_) { url = null; }
    if (url) {
      const external = document.createElement('a');
      external.href = url.href; external.target = '_blank'; external.rel = 'noopener noreferrer';
      external.className = 'ls-text-link'; external.textContent = 'Open calendar in a new tab ↗';
      url.searchParams.set('embed', 'true');
      const iframe = document.createElement('iframe');
      iframe.className = 'ls-calendar'; iframe.title = 'LA STORY bridal appointment calendar'; iframe.src = url.href;
      content.append(iframe, external);
    } else {
      const message = document.createElement('p');
      message.textContent = config?.dataset.unavailable || 'Online scheduling will be available soon. Please check back shortly.';
      content.append(message);
      if (window.Shopify?.designMode) {
        const help = document.createElement('p'); help.textContent = 'Add the LA STORY · Bridal booking section and enter your Koalendar URL.'; content.append(help);
      }
    }
    show(content, opener);
  }
  document.addEventListener('click', e => {
    if (!(e.target instanceof Element)) return;
    const book = e.target.closest('.ls-root [data-ls-book]');
    if (book) { e.preventDefault(); booking(book); return; }
    const preview = e.target.closest('.ls-root [data-ls-preview]');
    if (preview) {
      const template = document.getElementById(preview.dataset.lsPreview);
      if (template instanceof HTMLTemplateElement) show(template.content.cloneNode(true), preview);
      return;
    }
    if (e.target.closest('.ls-modal-host [data-ls-close]')) { state.dialog?.close(); return; }
    const toggle = e.target.closest('.ls-root [data-ls-menu]');
    if (toggle) {
      const nav = document.getElementById(toggle.getAttribute('aria-controls'));
      const open = nav?.classList.toggle('ls-open'); toggle.setAttribute('aria-expanded', String(!!open)); toggle.textContent = open ? '×' : '☰';
      return;
    }
    if (e.target.closest('.ls-nav a')) closeMenus();
  });
  function closeMenus() {
    document.querySelectorAll('.ls-nav.ls-open').forEach(n => n.classList.remove('ls-open'));
    document.querySelectorAll('[data-ls-menu]').forEach(b => { b.setAttribute('aria-expanded', 'false'); b.textContent = '☰'; });
  }
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeMenus(); });
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('ls-enter'); observer.unobserve(e.target); } });
  }, { threshold: 0.12 }) : null;
  function init(root = document) {
    if (window.Shopify?.designMode || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    root.querySelectorAll('.ls-root[data-ls-animate="true"] .ls-reveal').forEach(el => observer?.observe(el));
  }
  init();
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:section:unload', e => {
    e.target.querySelectorAll('.ls-reveal').forEach(el => observer?.unobserve(el));
    if (state.dialog?.open) state.dialog.close();
  });
  document.addEventListener('shopify:block:select', e => {
    const details = e.target.closest('details'); if (details) details.open = true;
  });
})();
